module.exports = __webpack_public_path__ + "static/img/tuoyuan.ba5e9c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bzhl/tuoyuan.png
// module id = E7mt
// module chunks = 1